module.exports = __webpack_public_path__ + "assets/img/28fca1f80a2829523c6204f8b0476f28.png";